export default __webpack_public_path__ + "static/123-bca85b795cd60f1ff3d1ff6bad224751.png";